import { useMemo } from 'react';
import type { GetViewFormItemsFilterRes } from 'types';

export interface UseReferencedFormItemsProps {
  filterViewFormItems?: GetViewFormItemsFilterRes['viewFormItems'];
}

export type ReferencedFormItemsMap = Map<string, string>;

export const useReferencedFormItems = ({ filterViewFormItems }: UseReferencedFormItemsProps): ReferencedFormItemsMap => {
  const referencedFormItemsMap = useMemo(() => {
    const map: ReferencedFormItemsMap = new Map();

    if (!filterViewFormItems) return map;

    const processReferencedItems = (items: UseReferencedFormItemsProps['filterViewFormItems'], parentId: string): void => {
      if (!items?.length) return;

      items.forEach((refItem) => {
        if (refItem?.formItem?.formItemId) {
          map.set(refItem.formItem.formItemId, parentId);
          processReferencedItems(refItem.referencedFormItems, refItem.formItem.formItemId);
        }
      });
    };

    filterViewFormItems.forEach((dataItem) => {
      if (!dataItem?.formItem?.formItemId || !dataItem.referencedFormItems?.length) return;

      const parentId = dataItem.formItem.formItemId;

      processReferencedItems(dataItem.referencedFormItems, parentId);
    });

    return map;
  }, [filterViewFormItems]);

  return referencedFormItemsMap;
};
